/**
* jv.candidate.appSource.controller Module
*
* Description
*/
angular.module('jv.candidate.appSource.controller', [])
    .controller('jvCandAppSourceController', ['$scope', '$routeParams', 'candidates', '$timeout', function($scope, $routeParams, candidates, $timeout){
        /**/
        $scope.appSource=$scope.appSource ||{};
        $scope.appSource.sourceTypes=[];
        
        /*@_all possible source types map <==> the list should be in sync with BE**/
        $scope.appSource.sourceKinds={
            /*@_[type:1]==> needs employee search for source name*/
            Referral: {category:'people', fieldId:''},
            EmployeeEntered: { category:'people', fieldId:''},
            EnteredForEmployee: { category:'people', fieldId:''},
            Agency: {category:'people', fieldId:'-21'},
            EnteredByRecruiter: { category:'people', fieldId:'-16'},
            EnteredByHiringManager: { category:'people', fieldId:'-17'},
            JobBoard:{category:'jobBoard'},
            /*@_prompt to enter text for source name*/
            Email: {category: 'text'},
            CustomWithName:{category:'text'},
            /*@_prompt a sub-list to select source-Name*/
            Custom:{category:'subType'},
            /*@_no source name required*/
            CareerSite:{},
            Notification:{},
            InternalApplication:{},
            InternalTransfer:{},
            Import:{},
            FederatedSearch:{},
            Share:{},
            ResumeSearch:{}
        };
        
        $scope.appSource.peopleSourceKinds= {
            'Hiring Manager': true,
            'Agency': true
        };

        /*@_this is required to pass specific search type parameter to employee-search ajax request*/
        $scope.appSource.personField= function(){
            var data={};
            data.fieldId = $scope.appSource.selectedSource.kind.fieldId;
            return data;
        };

        /*request for all source types to populate in list*/
        $scope.appSource.edit= function(){
            $scope.appSource.showError= false;
            candidates.appSourceTypes(function(response){
                $scope.appSource.sourceTypes= response.sourceTypes;
                $scope.appSource.setDefault(response.defaultSourceType, response.user);
                /*@Capturing viewFieldId for source on which selection should be posted back*/
                $scope.appSource.sourceEId= response.viewFieldEId;
            });
        };
        /*@_select default sources if its in response*/
        $scope.appSource.setDefault= function(defaultSourceType, userToSelect){
            angular.forEach($scope.appSource.sourceTypes, function(sourceType){
                if(sourceType.kind === defaultSourceType){
                    $scope.appSource.connectionEId=sourceType.EId;
                    $scope.appSource.selectSourceType(sourceType.EId);
                    /*@Set provided user as default selection*/
                    $timeout(function(){
                        $scope.appSource.selectedSource.employee=userToSelect;
                    },500);
                }
            });
        };

        if($scope.appSource.editMode){
            $scope.appSource.edit();
        }

        /*@_ called when Current Source is changed. Resets list if none is selected!*/
        $scope.appSource.selectSourceType= function(connectionEId){
            if(connectionEId){
                $scope.appSource.selectedSource={};
                $scope.appSource.selectedSource.sourceTypeId=connectionEId;
                $scope.appSource.showError=false;
                /*@_look for selected source in Source-List*/
                angular.forEach($scope.appSource.sourceTypes, function(sourceType){
                    if(sourceType.EId === connectionEId && $scope.appSource.sourceKinds[sourceType.kind]){
                        /*@_verified it in local source-list MAP*/
                        if($scope.appSource.sourceKinds[sourceType.kind].category){
                            /*@_retrieve category and kind property from local source-MAP for this selected Source*/
                            $scope.appSource.selectedSource.category= $scope.appSource.sourceKinds[sourceType.kind].category;
                            $scope.appSource.selectedSource.kind= $scope.appSource.sourceKinds[sourceType.kind];

                            /*@_if source is custom-type*/
                            if($scope.appSource.selectedSource.category === 'subType'){
                                if(sourceType.sourceTypes){
                                    /*@_need drop-down to be rendered to populate sub-Types*/
                                    $scope.appSource.selectedSource.subTypes= sourceType.sourceTypes;
                                }
                                else{
                                    /*@_**/
                                    $scope.appSource.selectedSource.category= 'subTypeWithoutTypes';
                                }
                            }
                            else if($scope.appSource.selectedSource.category ==='jobBoard') {
                                if($scope.appSource.selectedSource.jobBoardSourceName){
                                    data.sourceName = $scope.appSource.selectedSource.jobBoardSourceName; // eslint-disable-line
                                    if($scope.appSource.selectedSource.jobBoardSourceName.toUpperCase()=== 'JOBTARGET'){
                                        data.secondarySource = $scope.appSource.selectedSource.secondarySource; // eslint-disable-line
                                    }
                                }
                            }
                            /*@_Selected source needs TextBox to be rendered to add SourceName**/
                            else if($scope.appSource.selectedSource.category === 'text'){
                                $scope.appSource.selectedSource.promptText = true;
                                if(i18n['ENTER_'+sourceType.kind.toUpperCase()]){
                                    $scope.appSource.selectedSource.placeholder=  i18n['ENTER_'+sourceType.kind.toUpperCase()];
                                } else {
                                    $scope.appSource.selectedSource.placeholder = sourceType.promptText || i18n['ENTER_OTHER'];
                                }
                            }
                        }
                        else{
                            /*@_Doesn't need SourceName, if category property is not defined for Source in local source-map.**/
                            $scope.appSource.selectedSource.promptText = false;
                        }
                    }
                });
            }
            else{
                /*@_ resetting Source-Type should reset entire application-source section*/
                delete $scope.appSource.selectedSource;
            }
        };
            
        /*@_called only when Custom-Source with sub-types render one more drop-down for source name**/
        $scope.appSource.selectSubType= function(){
            if($scope.appSource.selectedSource.subTypeId && $scope.appSource.selectedSource.category==='subType'){
                /*@_making sure only Custom Source with SubTypes entering this section*/
                angular.forEach($scope.appSource.selectedSource.subTypes, function(subType){
                    /*@_looping through Sub-Types and deciding on action*/
                    if($scope.appSource.selectedSource.subTypeId === subType.EId){
                        $scope.appSource.selectedSource.subTypeName= subType.name;
                        if(subType.promptText){
                            /*@_custom source needs one more text-box to be rendered for Source-Name*/
                            $scope.appSource.selectedSource.promptText = true;
                            $scope.appSource.selectedSource.placeholder = subType.promptText;
                        }else{
                            /*@_No more control required for source-Name*/
                            $scope.appSource.selectedSource.promptText = false;
                        }
                    }
                });
            }else{
                /*@_reset in-case not called by Custom type with sub-types*/
                $scope.appSource.selectedSource.promptText = false;
                delete $scope.appSource.selectedSource.subTypeId;
            }
        };
                    
        /*@_validate*/
        $scope.appSource.validate= function(){
            var selectedSource=$scope.appSource.selectedSource;
            var errorMsg='';
            if($.isEmptyObject(selectedSource)){
                errorMsg= i18n['SELECT_CONNECTION'];
            }else{
                if(selectedSource.category === 'people' && $.isEmptyObject(selectedSource.employee)){
                    errorMsg= i18n['SELECT_A_EMPLOYEE'];
                }else if(selectedSource.category === 'subType' && (!selectedSource.subTypes || angular.isUndefined(selectedSource.subTypeId))){
                    errorMsg= i18n['SELECT_CUSTOM_TYPE'];
                }else if($scope.appSource.selectedSource.category === 'jobBoard' && angular.isUndefined($scope.appSource.selectedSource.jobBoardSourceName)){
                    errorMsg= i18n['SELECT_JOBBOARD_SOURCE'];
                }else if(selectedSource.promptText && !selectedSource.sourceText){
                    errorMsg= i18n['ENTER_SOURCE_NAME'];
                }
            }

            if(!errorMsg){
                /*@_ return structured post parameters ready to be posted if there is not error message*/
                return $scope.appSource.postParams(selectedSource, $scope.appSource.sourceEId);
            }
            return {error: errorMsg};
        };
        
        /*@_called before posting data! application source will accept ConnectionId as SourceType*/
        $scope.appSource.postParams= function(selectedSource, sourceEId){
            var data = {};
            if(angular.isDefined(selectedSource.sourceTypeId)){
             data[sourceEId] = selectedSource.sourceTypeId;
             /*@_ selected appSource info to be posted vary from one source to other*/
             if(selectedSource.category){
                    switch(selectedSource.category){
                        case 'people':
                        /*@_need to send complete user info*/
                            data[sourceEId] += '|' + selectedSource.employee.firstName + ' '+selectedSource.employee.lastName;
                            data[sourceEId] += '|' + selectedSource.employee.EId;
                            break;
                        case 'subType':
                        case 'subTypeWithoutTypes':
                        /*@_for custom sub-types*/
                            if(selectedSource.subTypes){
                                data[sourceEId] += '|' + selectedSource.subTypeName;
                                if(selectedSource.promptText){
                                    /*@_If custom source has Prompt text in Selected SubType. It should be appended to SubTypeName*/
                                    data[sourceEId] += ' : ' + selectedSource.sourceText;
                                }
                            }
                            break;
                        case 'jobBoard':
                            data[sourceEId] +=  '|' + selectedSource.jobBoardSourceName;
                            if(selectedSource.jobBoardSourceName.toUpperCase()==='JOBTARGET'){
                                data[sourceEId] += '|' + selectedSource.secondarySource;
                            }
                            break;
                        default:
                            /*@_Source name entered as prompt text*/
                            data[sourceEId] += '|' + selectedSource.sourceText;
                            break;
                        }
                    }
             }
            return data;
        };

        $scope.jobBoardSourceSelectConfig = {
            ajax: {
                type: 'GET',
                data: function (term) {
                    return {
                        keywords: term
                    };
                },
                results: function(data){
                    return {
                        results: data.sourceType
                    };
                }
            }
        };
    }]);